import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { INeedWeaningTableItem, NeedWeaningTableItem } from 'shared/api/api';
import sokort_icon from 'shared/assets/src-assets/png/sokort_icon.png';
import { getDateString } from 'shared/helpers/date-helpers';
import { NaturalSortDates } from 'shared/helpers/natural-sort';
import { GetDashboardGetNeedWeaningTable } from 'shared/state/ducks/dashboard/operations';
import { localized } from 'shared/state/i18n/i18n';
import { WebAppState } from 'web/state/store.web';
import SkioldTableGrid, {
	SkioldTableGrid as SkioldTableRef,
} from 'web/view/components/skiold-components/skiold-table/skiold-table-grid/skiold-table-grid';
import { ViewWeb } from 'web/view/components/utils/web-view';
import SowCard from 'web/view/pages/sow-card/sow-card';
import { GetNeedWeaningTableDashboardPdf } from 'web/web-helpers/pdf-helper/dashboard-pdf-helper.ts/dashboard-pdf-helper';
import { SkioldModal } from '../../skiold-components/skiold-modal/skiold-modal';
import { SkioldTouchableOpacity } from '../../skiold-components/skiold-touchable-opacity';
import { SowListConstants } from '../../stem-animal/animal-lists/table-constants';
import { Heading } from '../../utils/heading';
import { SkioldImage } from '../../utils/svg/skiold-image';
import { defaultSortingDashboardWeaningModals, getWebAnimalColorStyleDashboard } from '../dashboard-helper';
import { DashboardModalHeader } from '../dashboard-modal-header';
import { ClipLoader } from 'react-spinners';

interface PropsFromParent {
	batchId?: string;
	closeModal: () => void;
}

interface State {
	sowCardModal: boolean;
	stemAnimalId: string;
	data: INeedWeaningTableItem[];
	loading: boolean;
}

const mapStateToProps = (state: WebAppState, props: PropsFromParent) => {
	return {
		matingBatch: state.matingBatches.entities.find(mb => mb.id === props.batchId),
		profile: state.profile.active,
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => {
	return {
		GetDashboardGetNeedWeaningTable: (siteId: string, batchId: string) =>
			GetDashboardGetNeedWeaningTable(siteId, batchId),
	};
};

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & PropsFromParent;

export class NeedWeaningsDashboardTable extends React.PureComponent<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = { sowCardModal: false, stemAnimalId: '', data: [], loading: true };
	}

	public componentDidMount = () => {
		if (this.props.profile && this.props.profile.siteId && this.props.batchId) {
			this.props
				.GetDashboardGetNeedWeaningTable(this.props.profile.siteId, this.props.batchId)
				.then(d => this.setState({ data: d, loading: false }));
		}
	};
	public render() {
		return (
			<ViewWeb>
				<Heading text={localized('NeedWeaningTable')} />
				<DashboardModalHeader
					closeModal={this.props.closeModal}
					matingBatch={this.props.matingBatch}
					printData={this.printData}
				/>

				{this.state.loading ? (
					<ViewWeb className="spinner-container-active-dashboard">
						<ClipLoader color="#f2ac40" size={70} />
					</ViewWeb>
				) : (
					<ViewWeb className="dashboard-modal-table">
						<SkioldTableGrid
							sortHeaderId={defaultSortingDashboardWeaningModals}
							data={this.state.data}
							columns={this.generateColumns}
							ref={this.setTableRef}
							ColumnExtensions={this.getColumnExtenstions}
							usesSummaryRow={true}
							tableKey={'NeedWeaningsDashboardTable'}
						/>
						<SkioldModal
							shouldCloseOnOverlayClick={true}
							padding="0"
							isOpen={this.state.sowCardModal}
							close={this.closeModal}
							justify-content="flex-end"
							max-width="calc(100% - 220px)"
						>
							<SowCard stemAnimalIdFromParent={this.state.stemAnimalId} close={this.closeModal} />
						</SkioldModal>
					</ViewWeb>
				)}
			</ViewWeb>
		);
	}

	private printData = async () => {
		if (this.SkioldTableRef && this.props.profile && this.props.profile.siteId) {
			let data = this.SkioldTableRef.GetSortedData();
			GetNeedWeaningTableDashboardPdf(
				data,
				'NeedWeaning.pdf',
				this.props.profile.siteId,
				Intl.DateTimeFormat().resolvedOptions().timeZone,
				this.props.profile.language,
			);
		}
	};
	public SkioldTableRef: SkioldTableRef | undefined;
	private setTableRef = (m: any) => (m ? (this.SkioldTableRef = m) : {});
	private getColumnExtenstions = [
		{
			columnName: 'sowCard',
			filteringEnabled: false,
			width: SowListConstants.iconWidth,
		},
		{
			columnName: 'nursingDays',
			usesSummary: true,
			width: SowListConstants.pregnantDaysDashboardWidth,
		},
		{
			columnName: 'animalNr',
			width: SowListConstants.dateWidth,
		},
		{ columnName: 'breedRace', width: SowListConstants.animalNrWidth },
		{
			columnName: 'litter',
			width: SowListConstants.iDNumberWidth,
		},

		{
			columnName: 'farrowingDate',
			width: SowListConstants.iDNumberWidth,
		},
		{
			columnName: 'aliveBorn',
			usesSummary: true,
			width: SowListConstants.iDNumberWidth,
		},
		{
			columnName: 'stillborn',
			usesSummary: true,
			width: SowListConstants.iDNumberWidth,
		},
	];
	private showSowCard = (stemAnimalId?: string) => {
		if (stemAnimalId) {
			this.setState({ sowCardModal: true, stemAnimalId: stemAnimalId });
		}
	};

	private closeModal = () => {
		this.setState({ stemAnimalId: '', sowCardModal: false });
	};

	private generateColumns = [
		{
			name: 'sowCard',
			title: ' ',
			Footer: localized('avg'),
			sortable: false,
			getCellValue: (item: NeedWeaningTableItem) => (
				<SkioldTouchableOpacity itemFromParent={item.sowId} onPress={this.showSowCard}>
					<SkioldImage
						width={SowListConstants.iconSVGWidth}
						height={SowListConstants.iconSVGWidth}
						imageData={sokort_icon}
					/>
				</SkioldTouchableOpacity>
			),
		},
		{
			name: 'nursingDays',
			title: localized('NursingDays'),
			getCellValue: (item: NeedWeaningTableItem) => item.nursingDays,
		},
		{
			name: 'animalNr',
			title: localized('animalNr'),
			className: getWebAnimalColorStyleDashboard,
			getCellValue: (item: NeedWeaningTableItem) => item.animalNumber,
		},
		{
			name: 'breedRace',
			title: localized('Race'),
		},
		{
			name: 'litter',
			title: localized('Litters'),
			getCellValue: (item: NeedWeaningTableItem) => item.litterNumber,
		},
		{
			name: 'farrowingDate',
			title: localized('FarrowingDate'),
			sortFunction: NaturalSortDates,
			getCellValue: (item: NeedWeaningTableItem) => getDateString(item.farrowingDate),
		},
		{
			name: 'aliveBorn',
			title: localized('AliveBorn'),
			getCellValue: (item: NeedWeaningTableItem) => item.aliveBorn,
		},
		{
			name: 'stillborn',
			title: localized('stillborn'),
			getCellValue: (item: NeedWeaningTableItem) => item.stillborn,
		},
	];
}

export default connect(mapStateToProps, mapDispatchToProps)(NeedWeaningsDashboardTable);
